<template>
    <gofix-card fullContent class="mb-0">
        <!-- @row-click="openModalItem" -->
        <gofix-table :settings="tableConfig"
            :table-items="tableItems"
            @new-item="openModalItem"
            @load-items="getTableData"
            @row-click="openModalItem"
            @delete-items="deleteItems"
            ref="gofixTable">
            <template slot="gofix_table:sum" slot-scope="row">
                {{ row.item.sum | formatMoney }}
            </template>
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" size="lg" :title="modal.title" hide-footer :centered="true" v-model="modal.open" ref="modal-create-orders">
            <b-form class="formV2">
                <gofix-form-dropdown 
                    label="Location" 
                    :filterable="false" 
                    :options="modal.options.properties" 
                    v-model="modal.data.location" 
                    @search="searchProperty" 
                    vLabel="name" 
                    required 
                    show-icon-required>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <span v-b-tooltip.hover.top :title="option.root_path" v-html="$options.filters.highlightNode(option.root_path, key_search_property)"></span>
                    </template>
                </gofix-form-dropdown>
                <gofix-form-input-number 
                    label="Contract Sum" 
                    v-model="modal.data.sum" 
                    prefix="$">
                </gofix-form-input-number>
            </b-form>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="SUBMIT" @click="saveItem" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
import { filters } from '@/_filterVar.js'
export default {
    name: 'performance_assesment_contract_sum',
    props: {
        propertyType: {
            type: String,
            default: '',
        },
        contract: {
            type: Object,
            default: () => null,
        }
    },
    data() {
        let filter =  JSON.parse(JSON.stringify(filters['performance_assesment_contract_sum']));
        return {
            tableConfig:{
                name: 'performance-assesment-contract-sum',
                controls:{
                    create: true,
                    update: true,
                    delete: true,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                sortColumn: "id",
                sortDirection: "asc",
                itemSelected: [],
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width:50px",
                    },
                    {
                        key: 'location_path',
                        label: 'Location',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                    },
                    {
                        key: 'contract_name',
                        label: 'Supplier Contract',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                    },
                    {
                        key: 'sum',
                        label: 'Monthly Contract Sum',
                        isActive: 1,
                        isFilter: true,
                        sorting: true,
                        thClass: 'text-right',
                        tdClass: 'text-right'
                    },
                ]
            },
            tableItems: [],
            supplier_contracts: [],
            modal: {
                title: '',
                open: false,
                loading: false,
                options: {
                    properties: []
                },
                data: {
                    property_type: null,
                    contract_id: null,
                    location: null,
                    sum: null
                }
            },
            timer: {
                property: null,
                save: null
            }
        }
    },
    watch: {
        propertyType: function() {
            this.$refs.gofixTable.reloadTableItems();
        },
        contract: function() {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    filters: {
        highlightNode(val, option_selected) {
            if(option_selected) {
                if(option_selected.name) {
                    val = val.replace(option_selected.name, `<span class="d-inline font-weight-bold">${option_selected.name}</span>`);
                } else {
                    let regex = new RegExp(option_selected, "i");
                    let index = val.search(regex);
                    let substr = val.substr(index, option_selected.length);
                    val = val.replace(regex, `<span class="d-inline font-weight-bold">${substr}</span>`);
                }
            }

            return val;
        }
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest , resolve, reject } = await callback();
            if(!this.contract || !this.propertyType) {
                this.tableItems = []
                this.tableConfig.total = 0
                resolve({
                    items: [],
                    total: 0
                })
                return
            }
            tableRequest.filter.property_type.value = this.propertyType
            tableRequest.filter.contract_id.value   = this.contract.id
            tableRequest.type_setting = 'pa_contract_sum_setting'
            await this.$store.dispatch("PerformanceAssesmentSettingsController/getItems", tableRequest)
            .then(response => {
                this.tableItems = response.items;
                this.tableConfig.total = response.total;
                resolve(response);
            })
            .catch(err => {
                this.$alertNotification("Can not load the contract sum", "danger");
                reject();
            })
        },
        async deleteItems(callback){
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("PerformanceAssesmentSettingsController/deleteItems", {
                ids: ids,
                type: 'pa_contract_sum_setting'
            })
            .then(response => {
                resolve( 'Successfully deleted contract sum' );
            })
            .catch(err =>{
                reject(err);
            });
        },
        async openModalItem(item){
            if(item){
                this.modal.title = 'Edit Item'
                this.modal.data = Object.assign(this.modal.data, item)
            } else {
                if(!this.propertyType) return this.$alertNotification("Please select a property type", "danger");
                if(!this.contract) return this.$alertNotification("Please select a supplier contract", "danger");
                this.modal.title = 'Create Item'
                this.modal.data = {
                    property_type: this.propertyType,
                    contract_id: this.contract.id,
                    location: null,
                    sum: null
                }
            }

            this.searchProperty('', () => {})
            this.modal.open = true;
        },
        // 
        searchProperty(search, loading) {
            loading(true);
            this.properties = []
            if (this.timer.property) {
                clearTimeout(this.timer.property);
                this.timer.property = null;
            }
            this.timer.property = setTimeout(() => {
                this.key_search_property = search;
                const property_root_id = this.contract ? this.contract.property_root_id : (this.modal.data.supplier_contract ? this.modal.data.supplier_contract.property_root_id : null)
                const contract_id = this.contract ? this.contract.id : (this.modal.data.contract_id || null)
                this.$store.dispatch('PropertyController/getSearchProperties', {
                        keyword: search,
                        property_root_id: property_root_id,
                        limit: 100,
                        is_active: true,
                        property_type: this.modal.data.property_type,
                        contract_id: contract_id,
                    })
                    .then(response => {
                        this.modal.options.properties = response
                        loading(false);
                    })
                    .catch(err => {
                        loading(false);
                    })
            }, 500);
        },
        saveItem() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(() => {
                if(!this.modal.data.location) return this.$alertNotification("Location is required", "danger")
                if(!this.modal.data.sum) return this.$alertNotification("Sum is required", "danger")

                if(this.modal.loading) return
                this.modal.loading = true

                const request = {
                    id: this.modal.data.id || null,
                    property_type: this.modal.data.property_type,
                    contract_id: this.modal.data.contract_id,
                    location_id: this.modal.data.location.id,
                    location_name: this.modal.data.location.name,
                    sum: this.$accounting.unformat(this.modal.data.sum)
                }

                this.$store.dispatch(`PerformanceAssesmentSettingsController/${!request.id ? 'createContractSum' : 'updateContractSum'}`, request)
                    .then(response => {
                        this.modal.loading = false
                        this.modal.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        this.$alertNotification(this.$notificationV2(!request.id ? 'adding' : 'editing', 'pa_contract_sum'));
                    })
                    .catch(err => {
                        console.log(err)
                        this.modal.loading = false
                        if (err.response.data.error && err.response.data.error.message) {
                            this.$alertNotification(err.response.data.error.message, "danger")
                        }
                    })
            }, 200)
        }
    }
}
</script>